export const getTotalProgramPrice = (rooms) => {
  return rooms.reduce((total, room) => {
    const roomTotal = room.people.reduce((peopleTotal, person) => {
      return peopleTotal + (Number(person.program_price) || 0);
    }, 0);
    return total + roomTotal;
  }, 0);
};

export const getTotalDiscountSum = (rooms) => {
  return rooms.reduce((total, room) => {
    const roomTotal = room.people.reduce((peopleTotal, person) => {
      return peopleTotal + (Number(person.program_discount_sum) || 0);
    }, 0);
    return total + roomTotal;
  }, 0);
};

export const getTotalDiscountedPrice = (rooms) => getTotalDiscountSum(rooms);

export const getBookingDiscountText = (rooms) =>
  rooms
    .flatMap((room) => room.people)
    .map((person) => person.program_discount_text?.trim())
    .find(Boolean) || '';

export const hasBookingDiscount = (rooms) => {
  const totalSum = getTotalProgramPrice(rooms);
  const totalDiscountSum = getTotalDiscountSum(rooms);
  return totalDiscountSum > 0 && totalDiscountSum < totalSum;
};

export const guestHasDiscount = (person) => {
  const price = Number(person.program_price) || 0;
  const discountSum = Number(person.program_discount_sum) || 0;
  return discountSum > 0 && discountSum < price;
};
